import React, { useContext } from "react";
import { Search } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";

import { MapContext } from "fond/map/MapProvider";
import MapboxSearchBox from "fond/project/polygon/MapboxSearchBox";

import { useRightBarContext } from "./context";

import { Container, IconButton } from "./RightBar.styles";

const SearchField: React.FC = () => {
  const { expanded, setExpanded } = useRightBarContext();
  const { map } = useContext(MapContext);

  const toggleExpand = () => {
    setExpanded(expanded === "search" ? "none" : "search");
  };

  return (
    <Container>
      {expanded === "search" && map && (
        <Box>
          <MapboxSearchBox map={map} onSelectSearchResult={toggleExpand} />
        </Box>
      )}
      <Tooltip title="Search" placement="bottom" arrow>
        <IconButton aria-label="search" size="small" onClick={toggleExpand} sx={{ width: 28 }}>
          <Search sx={{ width: "1.25rem", height: "1.25rem" }} />
        </IconButton>
      </Tooltip>
    </Container>
  );
};

export default SearchField;
